import React, { Component } from 'react';
import { observer } from 'mobx-react';
import StopListStore from 'Stores/StopList/stopListStore';
import 'Styles/stopList.scss';
import StopListLine from 'Components/StopList/stopListLine';
import FiltersPanel from "Components/StopList/filtersPanel";
import FiltersStore from 'Stores/StopList/FiltersStore';
import Checkbox from "Components/Common/checkbox";
import SmrTable from "Components/Common/SmrTable";
import { ShowModal, CloseModal } from 'Utils/CommonFunctions';
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import Sorting from "Utils/Sorting";
import FiltersSimplePanel from "Components/Common/FiltersPanel/FiltersSimplePanel";
import { StopListItemDocumentDirection } from "Stores/models/Enums";

class StopList extends Component {
    constructor() {
        super();

        this.state = {
            errorToShow: null
        }
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Стоп-лист', 'stopList', this.ReloadData);

        this.ReloadData();
    }

    componentWillUnmount() {
        StopListStore.ClearStore();
        FiltersStore.ClearStore();
    }

    ReloadData() {
        StopListStore.ClearStore();
        FiltersStore.GetInitData();
        StopListStore.GetData();
        CloseModal();
    }

    handleScroll(event) {
        document.getElementById('table-header').scrollLeft = event.target.scrollLeft;
    }

    ShowStopListErrorModal(errorToShow) {
        ShowModal({
            className: 'stop-list-error-modal',
            header: [
                `Ошибка ${AppStore.isMeeting ? "совещания" : "документа"} Рег.№ ${errorToShow.regNum}`,
                errorToShow.contactName
            ]
                .filter(it => it?.length > 0)
                .join(' - '),
            canBeClosed: true,
            blockProductSwitcher: true,
            children: (
                <div>
                    <div className="user-title">Пользователь: {errorToShow.userName ?? 'все'}</div>
                    {errorToShow.contactName
                        ? (<div className="user-dl-title-container">ДЛ:&nbsp;<div className="user-dl-title">{`${errorToShow.contactName} - ${errorToShow.contactPost}`}</div>&nbsp;{`(${errorToShow.isMain ? 'основной' : 'второстепенный'})`}</div>)
                        : (<div>ДЛ: все</div>)
                    }
                    <br />
                    <span style={{ whiteSpace: 'pre-line' }}>
                        {errorToShow.errorText}
                    </span>
                </div>
            ),
            buttons: [
                {
                    content: 'Отменить',
                    closer: true
                },
                {
                    content: 'Распечатать в файл',
                    onClick: _ => StopListStore.PrintStopListItem(errorToShow.id)
                }
            ]
        });
    }

    ShowStopListCancelModal() {
        if (StopListStore.selectedRecordsIds
            .some(selectedRecordId =>
                StopListStore.tableStore.data
                    .find(it => it.id == selectedRecordId)
                    .direction == StopListItemDocumentDirection.FromSmrToDmsis)
        ) {
            ShowModal({
                className: 'stop-list-cancel-modal',
                canBeClosed: true,
                header: 'Отменить отправку',
                children: 'Данное действие удалит все операции пользователя, которые не были отправлены в СЭД. Вы уверены?',
                buttons: [{
                    content: 'Отменить',
                    closer: true
                }, {
                    content: 'Продолжить',
                    onClick: () => StopListStore.CancelSendFromStopList(),
                    closer: true
                }]
            });
        }
        else {
            StopListStore.CancelSendFromStopList();
        }
    }

    ShowErrorModal(error) {
        this.setState({ errorToShow: error });
        this.ShowStopListErrorModal(error);
    }

    renderTableLine(item) {
        return <StopListLine record={item}
            onSelectedChanged={(id, state) => StopListStore.SelectItemInTable(id, state)}
            onShowErrorClicked={errorInfo => this.ShowErrorModal(errorInfo)}
            key={`stop-list-item-${item.id}`} />
    }

    cleanTableData() {
        StopListStore.tableStore.CleanStore();
    }

    getSortableHeader(text, columnName) {
        return (
            <div className={columnName + "-column-width table-column-content-sortable " + columnName + "-column sortable"} onClick={() => this.SetSortOrderNext(columnName)}>
                {text} {this.GetSortOrderIcon(columnName)}
            </div>
        );
    }

    renderHeader() {
        return (
            <div className="stop-list-header-line stop-list-line-content">
                <div className="select-line-column">
                    <Checkbox
                        checked={(
                            StopListStore.records?.length > 0
                            &&
                            StopListStore.records?.every(record => StopListStore.selectedRecordsIds.some(id => id == record.id))
                        )}
                        onChange={(state) => StopListStore.SelectCurrentPageOfTable(state)}
                    />
                </div>
                {this.getSortableHeader('Рег. №', 'reg-num')}
                {this.getSortableHeader('Дата регистрации', 'reg-date')}
                {this.getSortableHeader('Пользователь', 'user-name')}
                <div className="show-error-column show-error-column-width">
                    Текст ошибки
                </div>
                {this.getSortableHeader('Время ошибки', 'error-date')}
            </div>
        );
    }

    GetSortOrderIcon(fieldName) {
        return Sorting.GetSortOrderIconParamValuesSort(FiltersStore.filters.sortRules, fieldName);
    }

    SetSortOrderNext(fieldName) {
        FiltersStore.filters.sortRules = Sorting.SetSortOrderNext(FiltersStore.filters.sortRules, fieldName);
        StopListStore.GetData();
    }

    render() {
        if (this.props.migrationNeeded) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        let retryAndCancelDisableClass = (StopListStore.selectedRecordsIds.length == 0 || StopListStore.processingRecordsIds.length > 0) ? 'disabled' : '';

        let tableButtonsPanel = {
            left: [
                <button onClick={() => StopListStore.GetData()}
                    key={'stop-list-left-button-panel-update'}>
                    Обновить
                </button>
            ],
            right: [
                <button onClick={() => StopListStore.RetrySendFromStopList()}
                    className={retryAndCancelDisableClass}
                    key={'stop-list-right-button-panel-retry'}>
                    Повторить отправку
                </button>,
                <button onClick={() => this.ShowStopListCancelModal()}
                    className={retryAndCancelDisableClass}
                    key={'stop-list-right-button-panel-cancel'}>
                    Отменить отправку
                </button>
            ]
        }

        return (
            <div className="StopList">
                <FiltersSimplePanel
                    className={(FiltersStore.initDataLoading || StopListStore.recordsLoading || StopListStore.totalRecordCount == 0 ? ' disabled' : '')}
                    getFiltersRender={() => FiltersStore.filtersRender}
                    getFilters={() => FiltersStore.filters}
                    clearFilters={() => {
                        FiltersStore.ClearFiltersRender();
                        FiltersStore.SaveFiltersFromRender();
                        StopListStore.GetData(1);
                    }}
                    visibleFiltersFieldNames={["regNumAlias", "matchWholeWord"]}
                    disabledFiltersFieldNames={FiltersStore.filters.includeInitiative ? ["regNumAlias", "matchWholeWord"] : null}
                    search={() => StopListStore.GetData(1)}
                    getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                    showFullFilters={() => {
                        ShowModal({
                            className: "filters-modal",
                            canBeClosed: true,
                            blockProductSwitcher: true,
                            header: 'Фильтрация данных',
                            children: (<FiltersPanel />),
                            buttons:
                                [
                                    {
                                        content: 'Очистить',
                                        closer: false,
                                        onClick: _ => FiltersStore.ClearFiltersRender()
                                    }, {
                                        content: 'Применить',
                                        closer: true,
                                        className: "blue-button",
                                        onClick: _ => {
                                            FiltersStore.SaveFiltersFromRender();
                                            StopListStore.GetData(1);
                                        }
                                    }
                                ],
                            width: '480px',
                            height: "90%"
                        });
                    }}
                />
                <SmrTable className="stop-list-table"
                    loading={StopListStore.recordsLoading}
                    renderTableLine={item => this.renderTableLine(item)}
                    cleanTableData={() => this.cleanTableData()}
                    renderHeader={() => this.renderHeader()}
                    getDataPage={pageToSet => StopListStore.GetData(pageToSet)}
                    location={this.props.location}
                    buttonsPanel={tableButtonsPanel}
                    setTableStore={store => StopListStore.SetTableStore(store)}
                />
            </div>
        )
    }
}

export default observer(StopList);